export const Sizes = {
  mobile: 700,
  tablet: 980,
  desktop: 1280,
};
